<!--
  price-comparison-card.vue

  2025-05-20: Initial creation. Price comparison card for Book Direct vs Airbnb.
  2025-05-20: Replaced all $t() i18n calls with hardcoded English text.
-->
<template>
  <v-card class="price-comparison-card rounded-xl" outlined>
    <v-card-title class="d-flex align-center justify-center pb-0">
      <v-icon color="success" class="mr-2">mdi-check-circle-outline</v-icon>
      <span class="font-weight-bold text-h6">{{
        $t("best_price_guarantee")
      }}</span>
    </v-card-title>
    <div
      class="text-body-2 text-center grey--text text--darken-1 px-6 pt-1 pb-6"
    >
      {{ $t("see_how_we_compare") }}
    </div>
    <v-card-text class="pt-0 pb-4 px-6">
      <div class="d-flex justify-space-between align-center mb-4">
        <span class="font-weight-semibold">{{ $t("book_direct") }}</span>
        <span class="direct-price">{{ directPrice }}</span>
      </div>
      <v-divider class="my-2" />
      <div class="d-flex justify-space-between align-center mb-1">
        <span class="grey--text">{{ $t("airbnb") }}</span>
        <span v-if="loading" class="grey--text"
          ><v-progress-circular
            indeterminate
            size="16"
            width="2"
            color="primary"
        /></span>
        <span v-else class="grey--text text-decoration-line-through">{{
          airbnbPrice
        }}</span>
      </div>
    </v-card-text>

    <div class="powered-by px-6 pb-3 pt-1 text-caption text-center">
      <slot name="powered">
        <span class="grey--text text--lighten-1">
          {{ $t("airbnb_trademark") }}
        </span>
      </slot>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "PriceComparisonCard",
  props: {
    directPrice: {
      type: String,
      required: true,
    },
    airbnbPrice: {
      type: String,
      required: false,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.price-comparison-card {
  box-shadow: 0 4px 24px 0 rgba(16, 30, 54, 0.08);
  border: none;
  .direct-price {
    background: #eaf8ef;
    color: #2e7d32;
    font-weight: 600;
    border-radius: 20px;
    padding: 4px 18px;
    font-size: 1.2rem;
    letter-spacing: 0.5px;
    display: inline-block;
  }
  .powered-by {
    line-height: 1.4;
  }
}
</style>
